import React from "react";
import vrBackground from "../assets/VR.jpg"; 
import carBackground from "../assets/driving.jpg"; 
import ps5Background from "../assets/ps5.jpg"; 
import switchBackground from "../assets/nintendo.jpg"; 
import vrShootingBackground from "../assets/VR3.jpg"; 

export default function VRSection() {
  return (
    <section className="w-full">

      {/* VR Section */}
      <div
        className="relative w-full min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-start"
        style={{ backgroundImage: `url(${vrBackground})` }}
      >
        <div className="absolute inset-0 bg-black/30 z-0" />
        <div className="relative z-10 w-full max-w-7xl px-6 flex flex-col items-start justify-center">
          <div className="relative text-left">
            <h1 className="text-[8rem] md:text-[14rem] leading-none font-bold relative text-white">
              VR
              <div className="absolute top-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <button className="bg-[#2f1b71] text-white px-8 py-3 rounded-full text-xs md:text-sm font-semibold shadow-lg hover:bg-[#3a1cb3] hover:cursor-default transition">
                  Virtual Reality
                </button>
              </div>
            </h1>
          </div>
        </div>
      </div>

      {/* Car Simulator Section */}
      <div
        className="relative w-full min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-end"
        style={{ backgroundImage: `url(${carBackground})` }}
      >
        <div className="absolute inset-0 bg-black/30 z-0" />
        <div className="relative z-10 w-full max-w-7xl px-6 flex flex-col items-end justify-center">
          <div className="relative text-left">
            <h1 className="text-[8rem] md:text-[14rem] leading-none font-bold relative text-white">
              CAR
              <div className="absolute top-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <button className="bg-[#2f1b71] text-white px-8 py-3 rounded-full text-xs md:text-sm font-semibold shadow-lg hover:bg-[#3a1cb3] hover:cursor-default transition">
                  Car Driving Simulator
                </button>
              </div>
            </h1>
          </div>
        </div>
      </div>

      {/* PS5 Section */}
      <div
        className="relative w-full min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-start"
        style={{ backgroundImage: `url(${ps5Background})` }}
      >
        <div className="absolute inset-0 bg-black/30 z-0" />
        <div className="relative z-10 w-full max-w-7xl px-6 flex flex-col items-start justify-center">
          <div className="relative text-left">
            <h1 className="text-[8rem] md:text-[14rem] leading-none font-bold relative text-white">
              PS5
              <div className="absolute top-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <button className="bg-[#2f1b71] text-white px-8 py-3 rounded-full text-xs md:text-sm font-semibold shadow-lg hover:bg-[#3a1cb3] hover:cursor-default transition">
                  PlayStation 5
                </button>
              </div>
            </h1>
          </div>
        </div>
      </div>

      {/* Nintendo Switch Section */}
      <div
        className="relative w-full min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-end"
        style={{ backgroundImage: `url(${switchBackground})` }}
      >
        <div className="absolute inset-0 bg-black/30 z-0" />
        <div className="relative z-10 w-full max-w-7xl px-6 flex flex-col items-end justify-center">
          <div className="relative text-left">
            <h1 className="text-[8rem] md:text-[14rem] leading-none font-bold relative text-white">
              SWITCH
              <div className="absolute top-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <button className="bg-[#2f1b71] text-white px-8 py-3 rounded-full text-xs md:text-sm font-semibold shadow-lg hover:bg-[#3a1cb3] hover:cursor-default transition">
                  Nintendo Switch
                </button>
              </div>
            </h1>
          </div>
        </div>
      </div>

      {/* VR Shooting Game Section */}
      <div
        className="relative w-full min-h-screen bg-cover bg-center bg-no-repeat flex items-center justify-start"
        style={{ backgroundImage: `url(${vrShootingBackground})` }}
      >
        <div className="absolute inset-0 bg-black/30 z-0" />
        <div className="relative z-10 w-full max-w-7xl px-6 flex flex-col items-start justify-center">
          <div className="relative text-left">
            <h1 className="text-[8rem] md:text-[14rem] leading-none font-bold relative text-white">
              VR
              <div className="absolute top-1/4 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                <button className="bg-[#2f1b71] text-white px-8 py-3 rounded-full text-xs md:text-sm font-semibold shadow-lg hover:bg-[#3a1cb3] hover:cursor-default transition">
                  Shooting Game
                </button>
              </div>
            </h1>
          </div>
        </div>
      </div>

    </section> 
  );
}
